import { Routes } from '@angular/router';

export const usersRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/users-shell/users-shell.component').then(
        (m) => m.UsersShellComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'registration-codes',
        loadComponent: () =>
          import('./components/registration-codes-tab/registration-codes-tab.component').then(
            (m) => m.RegistrationCodesTabComponent
          ),
      },
    ],
  },
];
